import React, { Component } from 'react';
import { Modal, Tabs, Button, Checkbox, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';

const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;
const basicOptions = [
    { label: '中心启动记录', value: 'SITE_START' },
    { label: '当月新启动中心', value: 'NEW_SITE_START' },
];

class ExportModal extends Component {
    state = {
        visible: false,
        values: [],
    }

    show = () => {
        this.setState({
            values: [],
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleCheckChange = (values) => {
        this.setState({ values });
    }

    submit = () => {
        const { sortParams, curParams } = this.props;
        const { values } = this.state;
        if (!(values || []).length) {
            message.warning('请选择导出内容！');
            return;
        }
        values.forEach(i => this.export(API_URL.dashboard.exportSiteStartRecord, { ...sortParams, ...curParams, type: i, offset: 1 }));
        this.hide();
    }

    export = (url, data) => {
        const options = {
            method: 'POST',
            url,
            data,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, values } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="400px"
                footer={<Button type="primary" onClick={this.submit}>确定</Button>}
            >
                <div>请选择导出内容:</div>
                <div style={{ marginLeft: 18, width: 210, lineHeight: '30px' }}>
                    <CheckboxGroup
                        value={values}
                        options={basicOptions}
                        onChange={this.handleCheckChange}
                    />
                </div>
            </Modal>
        );
    }
}

class Filter extends Component {
    render() {
        const { businessList, areaOptions, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计月份',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class SiteStartRecord extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.idToFieldMap = {};
        this.state = {
            data: [],
            columns: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        const { searchParams } = this.props;
        if (prevProps.searchParams !== searchParams) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({
                pagination,
                searchParams,
            }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.querySiteStartRecord,
            data: {
                type: 'SITE_START',
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data, treeData } = res;
                const { datas ,totalCount } = data;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                    columns: this.genColumns(treeData),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    genColumns = (treeData) => {
        const columns = [{
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'typeValue',
            key: 'typeValue',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '项目类型',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 80,
        }, {
            title: '计划启动中心数量',
            dataIndex: 'planAmount',
            key: 'planAmount',
            width: 80,
        }, {
            title: '截止当月已启动中心数量',
            dataIndex: 'sjqdscnt',
            key: 'sjqdscnt',
            width: 100,
        }, {
            title: 'PM工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: 'PM姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: 'PML工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 80,
        }, {
            title: 'PML姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        }, {
            title: '县级行政区（如无则默认为上级行政单位）',
            dataIndex: 'hospitalCounty',
            key: 'hospitalCounty',
            width: 80,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 120,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '启动服务类型(主导，协助，其他)',
            dataIndex: 'requirementInfoType',
            key: 'requirementInfoType',
            width: 110,
        }, {
            title: 'CRC工号',
            dataIndex: 'crcCode',
            key: 'crcCode',
            width: 120,
        }, {
            title: 'CRC姓名',
            dataIndex: 'crcName',
            key: 'crcName',
            width: 105,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 100,
        }, {
            title: '实际启动间隔',
            dataIndex: 'siteStartInterval',
            key: 'siteStartInterval',
            width: 105,
        }];
        (treeData || []).forEach(item => {
            const params = { title: item.ssuModuleStructureDefineName };
            if (item.children && item.children.length > 0) {
                const array = [];
                item.children.forEach(i => {
                    this.idToFieldMap[i.ssuModuleStructureDefineId] = i;
                    array.push({
                        title: i.ssuModuleStructureDefineName,
                        dataIndex: i.ssuModuleStructureDefineId,
                        key: i.ssuModuleStructureDefineId,
                        width: 120,
                    })
                });
                params.children = array;
            }
            columns.push(params);
        });
        return columns;
    }

    getDataSource = () => {
        const { data = [] } = this.state;
        const dataSource = (data || []).map(item => {
            const params = { ...item };
            (item.ssuModuleStructureDefineList || []).forEach(i => {
                if (i.ssuModuleStructureDefineName.endsWith('日期偏差')) {
                    params[i.ssuModuleStructureDefineId] = i.value ? `${i.value} 天` : null;
                } else {
                    const { valueShow, ssuModuleStructureDefineOptionList = [] } = this.idToFieldMap[i.ssuModuleStructureDefineId] || {};
                    if (i.value && i.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
                        params[i.ssuModuleStructureDefineId] = (ssuModuleStructureDefineOptionList.find(child => child.ssuModuleStructureDefineOptionId == i.value) || {}).ssuModuleStructureDefineOptionName;
                    } else if (i.ssuModuleStructureDefineWebType == 'TEXT_SEARCH_INPUT') {
                        params[i.ssuModuleStructureDefineId] = valueShow;
                    } else {
                        params[i.ssuModuleStructureDefineId] = i.value;
                    }
                }
            });
            return params;
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, pagination, sortParams, columns } = this.state;
        return (
            <TableC
                loading={loading}
                sortParams={sortParams}
                columns={columns}
                data={this.getDataSource()}
                className="siteStartRecord"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class NewSiteStart extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.idToFieldMap = {};
        this.state = {
            data: [],
            columns: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        const { searchParams } = this.props;
        if (prevProps.searchParams !== searchParams) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({
                pagination,
                searchParams,
            }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.querySiteStartRecord,
            data: {
                type: 'NEW_SITE_START',
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data, treeData } = res;
                const { datas ,totalCount } = data;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                    columns: this.genColumns(treeData),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    genColumns = (treeData) => {
        const columns = [{
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'typeValue',
            key: 'typeValue',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '项目类型',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 80,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 120,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        }, {
            title: '县级行政区（如无则默认为上级行政单位）',
            dataIndex: 'hospitalCounty',
            key: 'hospitalCounty',
            width: 80,
        }, {
            title: '实际递交立项资料的日期',
            dataIndex: 'actualSubmissionMaterialsDate',
            key: 'actualSubmissionMaterialsDate',
            width: 100,
        }, {
            title: '实际立项通过日期',
            dataIndex: 'actualSubmissionPassDate',
            key: 'actualSubmissionPassDate',
            width: 80,
        }, {
            title: '实际site启动日期',
            dataIndex: 'actualSiteStartDate',
            key: 'actualSiteStartDate',
            width: 80,
        }, {
            title: '启动时长',
            dataIndex: 'siteStartTime',
            key: 'siteStartTime',
            width: 80,
        }, {
            title: '启动月长',
            dataIndex: 'siteStartMonth',
            key: 'siteStartMonth',
            width: 80,
        }, {
            title: '启动服务类型',
            dataIndex: 'requirementInfoType',
            key: 'requirementInfoType',
            width: 80,
        }, {
            title: 'PML工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 80,
        }, {
            title: 'PML姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: 'PM工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: 'PM姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: 'CRC工号',
            dataIndex: 'crcCode',
            key: 'crcCode',
            width: 120,
        }, {
            title: 'CRC姓名',
            dataIndex: 'crcName',
            key: 'crcName',
            width: 105,
        }, {
            title: '职位',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 100,
        }];
        (treeData || []).forEach(item => {
            const params = { title: item.ssuModuleStructureDefineName };
            if (item.children && item.children.length > 0) {
                const array = [];
                item.children.forEach(i => {
                    this.idToFieldMap[i.ssuModuleStructureDefineId] = i;
                    array.push({
                        title: i.ssuModuleStructureDefineName,
                        dataIndex: i.ssuModuleStructureDefineId,
                        key: i.ssuModuleStructureDefineId,
                        width: 120,
                    })
                });
                params.children = array;
            }
            columns.push(params);
        });
        return columns;
    }

    getDataSource = () => {
        const { data = [] } = this.state;
        const dataSource = (data || []).map(item => {
            const params = {
                ...item,
                investigationSiteName: item.investigationSiteName,
            };
            (item.ssuModuleStructureDefineList || []).forEach(i => {
                if (i.ssuModuleStructureDefineName.endsWith('日期偏差')) {
                    params[i.ssuModuleStructureDefineId] = i.value ? `${i.value} 天` : null;
                } else {
                    const { valueShow, ssuModuleStructureDefineOptionList = [] } = this.idToFieldMap[i.ssuModuleStructureDefineId] || {};
                    if (i.value && i.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
                        params[i.ssuModuleStructureDefineId] = (ssuModuleStructureDefineOptionList.find(child => child.ssuModuleStructureDefineOptionId == i.value) || {}).ssuModuleStructureDefineOptionName;
                    } else if (i.ssuModuleStructureDefineWebType == 'TEXT_SEARCH_INPUT') {
                        params[i.ssuModuleStructureDefineId] = valueShow;
                    } else {
                        params[i.ssuModuleStructureDefineId] = i.value;
                    }
                }
            });
            return params;
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, pagination, sortParams, columns } = this.state;
        return (
            <TableC
                loading={loading}
                columns={columns}
                data={this.getDataSource()}
                sortParams={sortParams}
                className="byDepartment"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class SiteStart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            panes: [{
                title: '中心启动记录',
                key: 'siteStartRecord',
                content: this.getContent,
            }, {
                title: '当月新启动中心',
                key: 'newStartSite',
                content: this.getContent,
            }],
            activeKey: '',
            searchParams: {},
            curParams: {},
            businessList: [],
        };
    }

    componentDidMount() {
        this.queryEffectiveDate();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { year, month } = res;
            const { searchParams } = this.state;
            searchParams.date = format('month', year, month);
            this.setState({
                searchParams,
                activeKey: 'siteStartRecord',
                curParams: {...searchParams}
            });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({ curParams: {...searchParams} });
    }

    export = () => {
        this.exportRef.show();
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getContent = (key) => {
        const { activeKey, curParams } = this.state;
        if (key === activeKey) {
            switch(activeKey) {
                case 'siteStartRecord':
                    return <SiteStartRecord searchParams={curParams} />;
                case 'newStartSite':
                    return <NewSiteStart searchParams={curParams} />;
            }
        }
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    render() {
        const { exportable } = this.props;
        const { panes, activeKey, areaOptions, searchParams, sortParams, curParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    areaOptions={areaOptions}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
                </Tabs>
                <ExportModal ref={el => this.exportRef = el} sortParams={sortParams} curParams={curParams} />
            </div>
        );
    }
}

export default SiteStart;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/siteStart.js